<div class="events-table">
  <div class="events-table__rows">
    @if (eventsPage) {
      @for (event of eventsPage.data; track event.id) {
        <app-event-table-row [event]="event" />
      } @empty {
        <p class="events-table__empty">{{ emptyMessage }}</p>
      }
    } @else {
      <p-skeleton height="80px" />
      <p-skeleton height="80px" />
      <p-skeleton height="80px" />
    }
  </div>

  @if (showPagination && eventsPage && eventsPage.meta.total_count > 0) {
    <div class="events-table__pagination">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="eventsPage.meta.total_count"
        (onPageChange)="handlePageChange($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} de {totalRecords}"
        [showPageLinks]="false"
        [showFirstLastIcon]="false" />
    </div>
  }
</div>
